import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Header, Card, Image, Icon, Label, Divider } from "semantic-ui-react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';

import "./SimilarPlaces.css"

const SimilarPlaces = ({ data }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<>
        <Header as='h3'>{t("property:SimilarPlaces")}</Header>
        <Swiper        
            modules={[Navigation]}    
            navigation
            slidesPerView={1}
            autoplay={
                {
                    delay:50
                }
            }
        >
            {data && data.length !== 0 ? data.map((item, index) => {
                return (
                    <SwiperSlide>
                        <Card className="boxshadow-none m-1-auto">
                            <Card.Content>
                                <Card.Header className="d-flex flex-column">
                                    <Image src={item.img} className="rounded-10 zoom-on-hover" />
                                    <span className="font-bold m-1-t d-flex flex-row align-items-center"> {item.price} {t("property:Toman")} </span>
                                </Card.Header>
                                <Card.Description>
                                    <span className="d-flex flex-row align-items-center text-overflow-ell">
                                        <Label size="large" basic className="p-0 border-none d-flex flex-row align-items-center ">
                                            <Icon className="m-0 m-05-b" name='bed' />
                                            <span className="font-thin m-05-r m-05-l">{item.beds}</span>
                                        </Label>
                                        <Label size="large" basic className="p-0 border-none d-flex flex-row align-items-center ">
                                            <Icon className="m-0 m-05-b" name='bath' />
                                            <span className="font-thin m-05-r m-05-l">{item.baths}</span>
                                        </Label>
                                        <Label size="large" basic className="p-0 border-none d-flex flex-row align-items-center ">
                                            <Icon className="m-0 m-05-b" name='building' />
                                            <span className="font-thin m-05-r m-05-l">{item.area} {t("property:SquareMeter")}</span>
                                        </Label>
                                    </span>
                                    <Divider/>

                                    <Label size="large" basic className="p-0 font-thin border-none">
                                        {item.address}
                                    </Label>
                                </Card.Description>
                            </Card.Content>
                           
                        </Card>
                    </SwiperSlide>
                )

            }) : null}
        </Swiper>

    </>
    )
}
export default SimilarPlaces
